<template>
  <div class="text-left ">
    <EbHeading level="h1" class="eb-page-heading eb-upper-title">Mot de passe oublié&nbsp;?</EbHeading>
    
    <router-link :to="{name:'login'}" class="back-link"><font-awesome-icon :icon="['fas', 'chevron-left']" class="mr-5" /> Retour au formulaire de connexion</router-link>
    
    <EbBanner :isActive="showError" type="error" class="mt-24" :timestamp="bannerTimestamp" title="Erreur">
      <p><b>Ce compte ne semble pas exister, veuillez vérifier votre saisie.</b></p>
      <p>Problème de connexion ? <a href="https://assmat.maine-et-loire.fr/formulaire-de-contact">Contactez le Département de Maine-et-Loire</a></p>      
    </EbBanner>
    
    <div v-if="page==='confirm'">
      
      <EbBanner :isActive="page==='confirm'" type="info" title="Réinitialisation du mot de passe" class="mt-24">
        Merci de vérifier le contenu de votre boite mail
      </EbBanner>
      
      <p><strong>Un mail envoyé par «assmat.maine-et-loire.fr - Département de Maine-et-Loire» contenant un lien permettant de réinitialiser votre mot de passe, vient de vous être envoyé.<br>
        Ce lien expirera dans 24 heures.
      </strong></p>
      <p>
        Si vous ne trouvez pas le mail dans votre boite de réception : 
        <ul>
          <li>Vérifiez le contenu dans votre dossier Spam ou Courriers indésirables</li>
          <li><a href="mailto:numerique@maine-et-loire.fr" title="Contactez-nous - Fenêtre de messagerie">Contactez-nous <font-awesome-icon :icon="['fas', 'external-link-alt']" /></a> (numerique@maine-et-loire.fr)</li>
        </ul>
      </p>
    </div>
    <form v-else action="#" @submit.prevent="submitForm">
      <EbInput label="Identifiant" width="expand" v-model="identifiant" required helpText="Courriel ou nom d’utilisateur/utilisatrice"/>
      <EbButton type="submit" title="Envoyer le formulaire de mot de passe oublié" expanded="expanded" site-color="site-color">Envoyer</EbButton>
    </form>
    
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data() {
    return {
      identifiant: null,
      page: null,
      showError: false,
      bannerTimestamp: null
    }
  },
  mounted() {
    this.identifiant = this.$route.params.login
  },
  methods: {
    submitForm: async function() {
      await this.$http.post('authentification/motDePasseOublie', {
        identifiant: this.identifiant
      })
      .then(resp => {
        this.page="confirm"
        this.showError = false
      })
      .catch(error => {
        this.showError = true
        this.bannerTimestamp = this.getTime()
      })
    }
  }
}
</script>